import * as React from "react";
import type { SVGProps } from "react";
const SvgPaymentCardWithCheckMark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.5 20a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v4a1 1 0 0 1-2 0v-1h-16v5a2 2 0 0 0 2 2h8a1 1 0 0 1 0 2h-8Zm-2-12v1h16V8a2 2 0 0 0-2-2h-12a2 2 0 0 0-2 2Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M5.793 15.707a1 1 0 1 0 1.414-1.414 1 1 0 0 0-1.414 1.414ZM12.5 16h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2ZM17.553 20.894c.139.07.292.106.447.106h.02a1 1 0 0 0 .8-.43l3.5-5a1 1 0 0 0-1.64-1.14l-2.71 3.87-.67-.9a1 1 0 1 0-1.6 1.2l1.5 2a.999.999 0 0 0 .353.294Z"
    />
  </svg>
);
export default SvgPaymentCardWithCheckMark;
